<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header stacked="lg" striped hover :items="items" :fields="fields"
                    :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light"
                    class="sa-b-table">
                    <template v-slot:cell(titolo)="{ item }">
                        <router-link class="sa-edit-link" :to="'/agende/view/' + item.id">{{ item.titolo
                            }}</router-link>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-if="btnEditAgendaVisible" size="sm" variant="outline-secondary"
                                @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <b-icon icon="pencil" variant="outline-secondary"></b-icon>
                            </b-button>
                            <b-button size="sm" v-if="btnDeleteAgendaVisible" class="no-text" variant="outline-danger"
                                style="margin-right: 3px" @click="onDelete(row.item, row.index, $event.target)"><b-icon
                                    icon="trash" variant="outline-danger"></b-icon></b-button>
                            <b-button size="sm" class="no-text" variant="outline-info"
                                @click="onView(row.item, row.index, $event.target)">
                                <b-icon icon="calendar-event" variant="outline-primary" />
                            </b-button>
                            <condivisione-modal :idRisorsa="row.item.id" idSezione="agende"></condivisione-modal>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import CondivisioneModal from "../../utility/components/CondivisioneModal.vue";

export default {
    components: { CondivisioneModal },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    props: {
        utente: { type: Object },
    },
    mixins: [UtilityMixin],
    data() {
        return {
            currentPage: 1,
            rows: 0,
            perPage: 20,
            pathResource: "/agende",
            linkedit: "/agende",
            btnNewVisible: false,
            btnEditAgendaVisible: false,
            btnDeleteAgendaVisible: false,
            items: [],
            fields: [
                {
                    label: this.$i18n.t("agende.lblDiary"),
                    key: "titolo",
                    sortable: true,
                },
                {
                    label: this.$i18n.t("agende.lblDescription"),
                    key: "descrizione",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        utente() {
            let me = this;
            me.impostaPermessi();
        },
    },
    methods: {
        setUtente(utente) {
            console.log(utente);
        },
        impostaPermessi() {
            let me = this;
            me.btnNewVisible = UtilityMixin.methods.verificaPermessi(me.utente, "agende", 2);
            me.btnEditAgendaVisible = UtilityMixin.methods.verificaPermessi(me.utente, "agende", 4);
            me.btnDeleteAgendaVisible = UtilityMixin.methods.verificaPermessi(me.utente, "agende", 8);
        },
        loadData(filtroAgenda) {
            console.log("OK");
            this.openShowModalLoading();
            let me = this;
            me.impostaPermessi();
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            filtroAgenda.page = me.currentPage;
            filtroAgenda.forPage = me.perPage;
            console.log(filtroAgenda);

            me.$emit("beforeLoadData");
            axios
                .get(link, { params: filtroAgenda })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.length;
                    me.items = response.data.data;

                    this.$emit("afterLoadData");
                    this.closeShowModalLoading();
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                    this.closeShowModalLoading();
                });
        },
        onEdit(item) {
            let me = this;
            me.$router.replace(me.linkedit + "/edit/" + item.id).catch((err) => {
                err;
            });
        },
        onView(item) {
            let me = this;
            me.$router.replace(me.linkedit + "/view/" + item.id).catch((err) => {
                err;
            });
        },
        onDelete(item) {
            let me = this;
            console.log(item);
            this.$bvModal
                .msgBoxOk("Eliminare agenda " + item.titolo + " ?", {
                    title: "Eliminazione Agenda",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .then(() => {
                    let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + item.id;
                    axios
                        .delete(link)
                        .then((response) => {
                            this.$emit("delete", response)
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style></style>
